<template>
    <div class="jump-cart">
        <van-nav-bar title="购物车" left-arrow fixed class="jump-nav-bar"
                     @click-left="back"
                     @click-right="delContrl"
                     :right-text="isCart == 1 ? rightText: ''"
        />
        <div class="jump-cart-body" v-if="isCart == 1">
            <div class="jump-cart-body-hd"></div>
            <!-- <van-swipe-cell :right-width="65" class="jump-cart-item-hd" v-for="(cart,i) in cartList">
              <span slot="right" class="item-det" @click="removeCart(cart.id,i)">删除</span>
            </van-swipe-cell> -->
            <van-row class="jump-cart-item" type="flex" v-for="(cart,i) in cartList">
                <van-col span="2" class="text-center">
                    <van-checkbox @change="itemChange(cart)" v-model="cart.checked" :name="cart.cartId"
                                  :key="cart.cartId"></van-checkbox>
                </van-col>
                <van-col span="8" class="jump-cart-item-img">
                    <a :href="'#/gooddetail/'+cart.id"> <img v-bind:src="cart.picUrl"/></a>
                </van-col>
                <van-col span="14" class="jump-cart-item-warp">
                    <van-row>
                        <a :href="'#/gooddetail/'+cart.id">
                            <p>
                                  <span style="color: red;" v-if="cart.reservedFlag==1">预售
                                      <span v-if="cart.presellDate">(预计{{cart.presellDate}}日发货)</span>
                                  </span>
                                   <span style="color: red;" v-if="cart.reservedFlag!=1">正常</span>
                                  <span style="color:red" v-if="cart.combinationsNumber&&cart.combinationsNumber>0">(组合商品)</span>
                             
                              </p>
                              <h4>   {{cart.goodsName}}</h4>
                        </a>
                        <p v-if="cart.spec&&cart.spec!=''">规格:{{cart.spec}} </p>
                        <p>单价:￥{{cart.price}}</p>
                        <p v-if="cart.promotions != null && cart.promotions.length > 0">促销:
                            <span @click="showPromot(cart)" style="color:#f5a623">{{cart.defPromoText||cart.promotions[0].pname}} <van-icon
                                    name="arrow-down"/></span>
                        </p>
                        <p class="jump-cart-item-price">总价:￥{{cart.count * cart.price | numFilter}}</p>
                    </van-row>
                    <!--  cart.purchaseQuantity-->
                    <van-row class="van-stepper-countChange" v-if="cart.combinationsNumber&&cart.combinationsNumber>0">
                        <van-stepper input-width="50px" v-model="cart.count"  :min="cart.combinationsNumber" disabled />
                    </van-row>

                    <van-row class="van-stepper-countChange" v-else>
                        <van-stepper input-width="50px" v-model="cart.count"  :min="cart.purchaseQuantity" @change="countChange(cart,i)" 
                         async-change />
                    </van-row>

                </van-col>
            </van-row>

            <van-popup v-model="promosPop" position="bottom" :overlay="true">
                <van-picker
                        :columns="currPromots"
                        value-key="pname"
                        show-toolbar
                        @cancel="popPromotsCancel"
                        @confirm="popPromotsConfirm"
                />
            </van-popup>
            <div class="tip">
               <p  v-if="isZuHe">温馨提示：您购买的商品中包含组合优惠商品，享受优惠价格请保证所有组合商品在本次提交的订单中 </p>
            </div>
           

            <van-submit-bar
                    v-if="!isDel"
                    class="cart-shop"
                    :price="cartTotal"
                    button-text="结算"
                    @submit="cartSubmit">
                <van-checkbox v-model="checkedAll" @click="checkAll">全选</van-checkbox>
            </van-submit-bar>
            <van-submit-bar
                    v-if="isDel"
                    class="cart-shop"
                    button-text="删除"
                    @submit="cartDel">
                <van-checkbox v-model="checkedAllDel" @change="checkAllDel">全选</van-checkbox>
            </van-submit-bar>
        </div>
        <div class="jump-cart-body" v-if="isCart == 0">
            <div class="no-cart-hd">
                <img src="../assets/img/no_cart.png"/>
                <p>购物车空空如也，快去逛逛吧!</p>
                <van-button size="large" url="#/">马上选购</van-button>
            </div>
        </div>
        <van-tabbar v-model="tabActive" active-color="#3c6eeb">
            <van-tabbar-item url="#/home">
                <i slot="icon" class="iconfont icon-shouye"></i>
                首页
            </van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/cate">
                <i slot="icon" class="iconfont icon-icon-"></i>
                分类
            </van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/message/center">
                <i slot="icon" class="iconfont icon-ico_msg"></i>
                消息
            </van-tabbar-item>
            <van-tabbar-item icon="cart-o" url="#/cart">
                <i slot="icon" class="iconfont icon-gouwuche1"></i>
                购物车
            </van-tabbar-item>
            <van-tabbar-item icon="contact" url="#/usercent">
                <i slot="icon" class="iconfont icon-ziyuan2"></i>
                我的
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
    import {
        NavBar,
        SubmitBar,
        Checkbox,
        CheckboxGroup,
        Row,
        Col,
        Stepper,
        Button,
        SwipeCell,
        Tabbar,
        TabbarItem,
        Popup, Picker,NoticeBar
    } from "vant";

    export default {
        name: "cart",
        components: {
            [NavBar.name]: NavBar,
            [SubmitBar.name]: SubmitBar,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Row.name]: Row,
            [Col.name]: Col,
            [Stepper.name]: Stepper,
            [Button.name]: Button,
            [SwipeCell.name]: SwipeCell,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar
            
        },
        data() {
            return {
                tabActive: 3,
                checkedAll: false,
                checkedAllDel: false,
                isCart: -1,
                cartList: [],
                cartIds: [],//购物ids
                reservedFlags:[],//存储商品的状态，1预售，正常
                isZuHe:false,
                goodsPromotionMap: [],//促销s
                cartTotal: 0,
                isDel: false,
                rightText: '编辑',
                promosPop: false,
                currPromots: [],
                popCart: {},//促销选中cart
                spec:'',//规格
                reservedFlagSendTime:0,
            };
        },
        methods: {
            back() {
                //history.back();
                location.href = "#/home"
            },
            showPromot(cart) {
                this.popCart = cart;
                this.currPromots = cart.promotions;
                this.promosPop = true;
            },
            popPromotsCancel() {
                this.promosPop = false;
            },
            popPromotsConfirm(promoItem) {
                this.promosPop = false;
                this.popCart.defPromoText = promoItem.pname;
                this.popCart.defPromoId = promoItem.id;
                this.calcTotalPrice();
            },
            delContrl(e) {
                e.preventDefault();
                if (!this.isDel) {
                    this.isDel = true;
                    this.rightText = '取消';
                } else {
                    this.isDel = false;
                    this.rightText = '管理';
                }
            },
            cartDel() {
                let that = this;
                if (this.cartIds.length == 0) {
                    this.$toast('请选择要删除的商品');
                    return;
                }
                that.$api.post(that.jumuc.cart.remove, {cartIds: this.cartIds.join()}, successRes => {
                    if (successRes.success) {
                        that.$toast('删除成功');
                        that.loadCart();
                    }
                })
            },
            checkAllDel() {
                this.cartIds = [];
                for (var i in this.cartList) {
                    this.cartList[i].checked = this.checkedAllDel;
                }
            },
            removeCart(id, i) {
                let that = this;
                that.$api.post(that.jumuc.cart.remove, {cartId: id}, successRes => {
                    if (successRes.success) {
                        that.cartList.splice(i, 1);
                        that.calcTotalPrice();
                    }
                })
            },
            checkAll() {
                this.cartIds = [];
                this.cartTotal = 0;
                for (var i in this.cartList) {
                    this.cartList[i].checked = !this.checkedAll;
                }
                if (this.checkedAll) {
                    this.calcTotalPrice();
                }
            },
            //checkCout(cart) {
                // if (cart.count < 1) {
                //     cart.count = cart.purchaseQuantity;
                // }
            //},
            countChange(cart, i) {
                let that = this;
                if (cart.count > 1 && cart.count < cart.purchaseQuantity) {
                    that.$toast("该商品最小起购数量为" + cart.purchaseQuantity);
                    //that.cartList[i].count = cart.purchaseQuantity;
                    /* setTimeout(() => {
                         cart.count = cart.purchaseQuantity;
                     }, 100);*/
                    return;
                }
                that.$api.post(that.jumuc.cart.changeCount, {cartId: cart.cartId, count: cart.count},
                    successRes => {
                        if (successRes.success) {
                            cart.promotions = successRes.data.promotions;
                            if (cart.promotions && cart.promotions.length > 0) {
                                cart.defPromoText = cart.promotions[0].pname;
                                cart.defPromoId = cart.promotions[0].id;
                            } else {
                                cart.defPromoId = 0;
                            }
                            that.calcTotalPrice();
                        } else {
                            that.$toast(successRes.msg);
                            // if (successRes.data != null && cart.count > 0) {
                            //     cart.count = successRes.data
                            // }
                        }
                    }
                )
            },
            itemChange() {
                let j = 0;
                for (var i in this.cartList) {
                    if (this.cartList[i].checked) {
                        j = j + 1;
                    }
                }
                if (j == this.cartList.length) {
                    this.checkedAll = true;
                } else {
                    this.checkedAll = false;
                }
                this.calcTotalPrice();
            },
            calcTotalPrice() {
                let that = this;
                this.cartIds = [];
                this.reservedFlags=[];
                this.cartTotal = 0;
                 this.isZuHe=false;
                that.goodsPromotionMap = [];
                for (var i in that.cartList) {
                    if (that.cartList[i].checked) {
                        that.cartIds.push(that.cartList[i].cartId);
                        if(that.cartList[i].combinationsNumber&&that.cartList[i].combinationsNumber>0){
                            this.isZuHe=true;
                        }
                        that.reservedFlags.push(that.cartList[i].reservedFlag);
                        that.cartTotal += that.cartList[i].price * that.cartList[i].count;
                        //促销
                        if (that.cartList[i].defPromoId) {
                            that.goodsPromotionMap.push(that.cartList[i].cartId + "_" + that.cartList[i].defPromoId);
                        } else if (that.cartList[i].promotions != null && that.cartList[i].promotions.length > 0) {
                            that.goodsPromotionMap.push(that.cartList[i].cartId + "_" + that.cartList[i].promotions[0].id);
                        }
                    }
                }
                that.cartTotal = that.cartTotal * 100;
            },
            cartSubmit() {
                let that = this
                if (that.cartIds.length == 0) {
                    that.$toast('请选择要结算的商品');
                    return;
                }
                that.$api.post(that.jumuc.cart.checkOrder, {
                        checkedCartIds: that.cartIds,
                        goodsPromotionMap: that.goodsPromotionMap.join()
                    },
                    successRes => {
                        if (successRes.success) {
                            location.href = "#/order?checkedCartIds=" + that.cartIds.join() + ',&goodsPromotionMap=' + that.goodsPromotionMap.join();
                        } else {
                            that.$toast(successRes.msg);
                        }
                    }
                );

            },
            loadCart() {
                let that = this;
                that.$api.post(that.jumuc.cart.list, {},
                    successRes => {
                        for (var i in successRes.data) {
                            successRes.data[i].checked = false;
                        }
                        that.cartList = successRes.data;
                        that.isCart = successRes.data.length > 0 ? 1 : 0;
                    }
                )
                //获取预售商品的天数
                // that.$api.get(that.jumuc.cart.getConfig, {},
                //     successRes => {
                //        if(successRes.success){
                //            this.reservedFlagSendTime=successRes.data.reservedFlagSendTime;
                //            localStorage.setItem('reservedFlagSendTime',this.reservedFlagSendTime);
                //        }
                //     }
               // )
            }
        },
        // beforeCreate() {
        //     let that = this;
        //     if (!that.$api.isLogin()) {
        //         console.log('11')
        //         location.href = "#/login";
        //         localStorage.setItem('cartSign', true);
        //     }
        // },
        mounted() {
            this.loadCart();
        }, filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2)
                return realVal
            }
        },
    };
</script>
<style lang="less">
    .jump-cart-item .van-checkbox__icon--checked .van-icon,
    .cart-shop .van-checkbox__icon--checked .van-icon {
        border-color: #ed683a;
        background-color: #ed683a;
    }
</style>

<style lang="less" scoped>
    @bule-thame: #3c6eeb;
     #app .van-nav-bar .van-nav-bar__text{
         background:@bule-thame;
     }
    body {
        background-color: #f7f7f7;
    }

    .jump-cart {
        p {
            margin-top: 5px;
        }
        .van-stepper-countChange {
            text-align: right;
            padding-right: 10px;
            padding-top: 10px;
        }
        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        .van-submit-bar {
            .van-checkbox {
                margin-left: 10px;
            }
        }
        .van-submit-bar {
            .van-button {
                background-color: #f5a623;
                border-color: #f5a623;
            }
        }
        &-body {
            padding: 20px 10px 100px;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            padding: 10px 0 20px 0;
            align-items: center;
            border-radius: 20px;
            position: relative;
            margin-bottom: 15px;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
            }
            &-price {
                color: red;
            }
            &-num {
                position: absolute;
                right: 20px;
                bottom: 10px;
            }
        }
        .no-cart-hd {
            text-align: center;
            img {
                width: 80%;
            }
            p {
                color: #999;
                font-size: 14px;
                padding: 15px 0;
            }
            button {
                width: 50%;
                color: #fff;
                border-color: @bule-thame;
                background-color: @bule-thame;
                border-radius: 25px;
                margin-top: 20px;
            }
        }

        .jump-cart-item-hd {
            border-radius: 20px;
            background-color: #fff;
            margin-bottom: 15px;
            .van-swipe-cell__right {
                background-color: #f00;
                color: #fff;
                width: 65px;
                text-align: center;
                span {
                    display: inline-block;
                    margin-top: 100%;
                }
            }
        }
    }

    .cart-shop.van-submit-bar {
        bottom: 50px;
    }
    .tip{
        font-size: 14px;
    position: fixed;
    bottom: 100px;
    left: 0;
    right: 0;
    color: red;
    padding: 10px;
    background: #fff;
    }
</style>

